export const storeKey = 'root';
